import { useEffect, useState } from "react";
import useFormStore from "../../store/formData";
import ImageInput from "../ImageInput/ImageInput";

const ImageInputContainer = (props) => {
  const { formData, setFormData } = useFormStore();
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    formData[props.data.id] && setImageSrc(formData[props.data.id]);
  }, []);

  function onChangeHandler(key, value) {
    setImageSrc(value);
    setFormData(key, value);
  }

  return (
    <ImageInput
      name={props.data.name}
      id={props.data.id}
      onChangeHandler={onChangeHandler}
      imageSrc={imageSrc}
    />
  );
};

export default ImageInputContainer;
